export class IntegratedPlannerModel {
  id: number | null = null;
  parentId: number | null = null;
  userSessionValues = {};
  selector: string = '';
  selectedItemIds: string = '';
  selectedAccountIds: string = '';
  groupNo: number = 1;
  userFBForecastId: number = 0;
  isOpenSaved: boolean = false;
  isMultipleNavigation: boolean = false;
  selectedMeasureType: string | null = null;
  plannerName: string | null = null;
}
